export default "__VITE_ASSET__Drqu_EKv__"